/**
 * Strip simple HTML tags for meta description fallback.
 */
export function stripHtmlToText(html: string): string {
  return html
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim()
}

function extractFromTipTapDoc(doc: unknown): string {
  if (!doc || typeof doc !== "object") return ""
  const root = doc as { content?: unknown[] }
  const blocks = root.content
  if (!Array.isArray(blocks)) return ""
  const parts: string[] = []
  for (const block of blocks) {
    if (!block || typeof block !== "object") continue
    const b = block as { content?: Array<{ text?: string }> }
    const inner = b.content
    if (!Array.isArray(inner)) continue
    for (const node of inner) {
      if (node?.text) parts.push(node.text)
    }
  }
  return parts.join(" ").trim()
}

/**
 * First usable text from ordered page sections for meta description (max ~160 chars).
 */
export function extractDescriptionFromPageSections(
  sections: Array<{
    section_type: string
    order_index?: number
    content: Record<string, unknown> | null
  }>,
  maxLen = 160
): string {
  const sorted = [...sections].sort((a, b) => {
    const ai = typeof a.order_index === "number" ? a.order_index : 0
    const bi = typeof b.order_index === "number" ? b.order_index : 0
    return ai - bi
  })

  for (const s of sorted) {
    const c = s.content
    if (!c) continue
    const type = s.section_type

    if (type === "paragraph" || type === "heading") {
      const plain = typeof c.text === "string" ? c.text : ""
      if (plain.trim()) {
        const t = stripHtmlToText(plain)
        if (t) return t.length <= maxLen ? t : `${t.slice(0, maxLen - 1).trim()}…`
      }
      const fromDoc = extractFromTipTapDoc(c.content)
      if (fromDoc) {
        const t = stripHtmlToText(fromDoc)
        if (t) return t.length <= maxLen ? t : `${t.slice(0, maxLen - 1).trim()}…`
      }
    }
  }

  return ""
}
